module.exports = __webpack_public_path__ + "img/muzz.75c85671.jpg";